export default __webpack_public_path__ + "static/media/virus3.302f9711.png";